import { CFDStatus } from "features/cfd/state/cfdAtoms";
import {
  determinePresetId,
  OBJECTIVE_PRESETS,
  ObjectiveKey,
  ObjectivePresetId
} from "shared/domain/objectivePresets";
import { alertAuthExpired, fetchFfdJson } from "shared/api/ffdClient";

export const fetchCFDResult = async (
  authToken: string,
  name: string
): Promise<CFDStatus | null> => {
  try {
    const { response, data } = await fetchFfdJson<{ body: any }>(
      `/cfd/result?study_name=${encodeURIComponent(name)}`,
      authToken
    );
    const presetId: ObjectivePresetId = data.body?.presetId
      ? data.body.presetId as ObjectivePresetId
      : determinePresetId(data.body?.value || data.body?.cd || data.body?.cfd_id || {});

    const objectives: ObjectiveKey[] =
      (data.body?.objectives as ObjectiveKey[] | undefined) ??
      OBJECTIVE_PRESETS[presetId].objectives.map((meta) => meta.key);

    const cfd_id: Record<ObjectiveKey, string> = {} as Record<ObjectiveKey, string>;
    const value: Record<ObjectiveKey, number> = {} as Record<ObjectiveKey, number>;
    const status: Record<ObjectiveKey, string> = {} as Record<ObjectiveKey, string>;

    OBJECTIVE_PRESETS[presetId].objectives.forEach((meta) => {
      cfd_id[meta.key] = data.body?.cfd_id?.[meta.key] ?? '';
      const v = data.body?.value?.[meta.key] ?? data.body?.cd?.[meta.key];
      const num = Number(v);
      value[meta.key] = Number.isFinite(num) ? num : NaN;
      status[meta.key] = data.body?.status?.[meta.key] ?? '';
    });

    return {
      status_code: response.status,
      name,
      presetId,
      objectives,
      cfd_id,
      value,
      status,
      error_code: data.body?.error_code ?? null,
    };
  } catch (error) {
    alertAuthExpired();
    return null;
  }
};
